import React, { useState } from 'react';
import { Modal, Popover, Tooltip } from 'antd';
import IconCheckbox from '../../icon-checkbox';
import PriorityList from '../PriorityList/PriorityList';

const CLOSE_STATUS_ID = 3;

const PrioritiesPanel = ({ record, onChange, ...props }) => {
  return (
    <PriorityList
      render={({ priorities }) => (
        <div {...props}>
          {priorities?.map((p) => (
            <div
              key={p.id}
              style={{ marginTop: 10 }}
            >
              <IconCheckbox
                value={record?.priority?.id === p?.id}
                onChange={() => onChange(p)}
              >
                {p.code} - {p.name}
              </IconCheckbox>
            </div>
          ))}
        </div>
      )}
    />
  );
};

export const ChangePriority = ({ record, onOk, children }) => {
  const [visible, setVisible] = useState(false);

  const handleChange = (priority) => {
    setVisible(false);

    const selectedPriority = record?.priority?.id === priority?.id;

    Modal.confirm({
      title: 'Изменить приоритет заявки?',
      content: (
        <div>
          Заявка: <strong>{record.id}</strong>
          <br />
          {selectedPriority ? (
            <>
              Убрать приоритет заявки <strong>{priority.name}</strong>
            </>
          ) : (
            <>
              Установить приоритет заявки <strong>{priority.name}</strong>
            </>
          )}
        </div>
      ),
      onOk: () => {
        onOk({
          requestId: record.id,
          priority:
            record?.priority?.id === priority?.id ? { id: 0 } : priority,
        });
      },
      onCancel: () => {},
    });
  };

  return (
    <Popover
      placement="right"
      content={
        <PrioritiesPanel
          record={record}
          onChange={handleChange}
        />
      }
      title={
        <div>
          <span>Приоритет заявки</span>
        </div>
      }
      trigger="click"
      visible={visible}
      onVisibleChange={(v) => setVisible(v)}
    >
      {children}
    </Popover>
  );
};

const RequestPriority = ({ record, onOk, iconStyle, isStatistics = false }) => {
  const content = (
    <Tooltip
      mouseLeaveDelay={0}
      title={record?.priority?.name}
    >
      {record.priority ? (
        <span style={iconStyle}>{record.priority.code}</span>
      ) : undefined}
    </Tooltip>
  );

  const canChange = typeof onOk === 'function' && !isStatistics;

  return canChange ? (
    <ChangePriority
      record={record}
      onOk={onOk}
    >
      {content}
    </ChangePriority>
  ) : (
    content
  );
};

export default RequestPriority;
